import $ from 'jquery'
import {Core} from './core'

export class Sticky {

  constructor() {
    this.$body = $('body')
    this.$header = $('header')

    this.classes = {
      bannerContentTopClass: 'banner-top-content'
    }

    this.stickyClasses = {
      top: 'js-sticky-top',
      middle: 'js-sticky-middle',
      bottom: 'js-sticky-bottom'
    }

    this.stickyDatas = {
      bp: 'js-sticky-bp',
      mobile: 'js-sticky-mobile',
      desktop: 'js-sticky-desktop',
      parentTop: 'js-sticky-parent-top',
      parentBottom: 'js-sticky-parent-bottom',
      middleWidthOffset: 'js-sticky-middle-width-offset',
      topOffsetDesktop: 'js-sticky-top-offset-desktop',
      topOffsetMobile: 'js-sticky-top-offset-mobile',
    }

    this.previousScroll = 0

    this.$bannerContentTop = $(`.${this.classes.bannerContentTopClass}`)

    this.bigSubmenuClass = 'big-submenu-wrapper'
    this.$bigSubmenu = $(`.${this.bigSubmenuClass}`)

    $(window).on('resize scroll', this.handleStickyNav.bind(this))

    setTimeout(this.handleStickyNav.bind(this), 150)
  }

  stickyNav(index, element) {
    if ( ! this.$header.length ) {
      return
    }

    let $element = $(element)
    let windowHeaderTop = 0
    let stickyBp = $element.data(this.stickyDatas.bp) ?? 'md'
    let stickyTopOffset = 0

    if (Core.isBpGreaterThan(stickyBp)) {
      if ($element.data(this.stickyDatas.desktop) === undefined) {
        this.resetClasses($element)
        return
      }

      if ($element.data(this.stickyDatas.topOffsetDesktop) !== undefined) {
        stickyTopOffset = $element.data(this.stickyDatas.topOffsetDesktop)
      }
    } else {
      if ($element.data(this.stickyDatas.mobile) === undefined) {
        this.resetClasses($element)
        return
      }

      if ($element.data(this.stickyDatas.topOffsetMobile) !== undefined) {
        stickyTopOffset = $element.data(this.stickyDatas.topOffsetMobile)
      }
    }

    if ($element.hasClass(this.classes.bannerContentTopClass)) {
      windowHeaderTop = 0
    } else {
      // Position réelle du bas du header fixed, quelle que soit la direction du scroll :
      // suit la banner-top, l'admin bar et le header masqué
      // (translateY(-300%) donne une valeur négative, clampée à 0 plus bas)
      windowHeaderTop = this.$header.offset().top - this.currentScroll + this.$header.outerHeight(true)

      // Se caler sous le big submenu quand il est sticky à l'écran
      if (!$element.hasClass(this.bigSubmenuClass) && this.$bigSubmenu.hasClass(this.stickyClasses.middle)) {
        windowHeaderTop = Math.max(windowHeaderTop, this.$bigSubmenu.offset().top - this.currentScroll + this.$bigSubmenu.outerHeight(true))
      }
    }

    windowHeaderTop += stickyTopOffset

    let scrollTopHeader = this.currentScroll + windowHeaderTop
    let $stickyParentTop = $element.parent()
    let $stickyParentBottom = $element.parent()

    if ($element.data(this.stickyDatas.parentTop) !== undefined) {
      const selectorTop = $element.data(this.stickyDatas.parentTop)
      const $closestTop = $element.closest(selectorTop)
      if ($closestTop.length) {
        $stickyParentTop = $closestTop
      } else {
        const $section = $element.closest('section')
        $stickyParentTop = ($section.length ? $section.find(selectorTop) : $(selectorTop)).first()
      }
    }

    if ($element.data(this.stickyDatas.parentBottom) !== undefined) {
      const selectorBottom = $element.data(this.stickyDatas.parentBottom)
      const $closestBottom = $element.closest(selectorBottom)
      if ($closestBottom.length) {
        $stickyParentBottom = $closestBottom
      } else {
        const $section = $element.closest('section')
        $stickyParentBottom = ($section.length ? $section.find(selectorBottom) : $(selectorBottom)).first()
      }
    }

    let stickyTop = $stickyParentTop.offset().top
    let stickyBottom = $stickyParentBottom.offset().top + $stickyParentBottom.outerHeight(true) - $element.outerHeight(true)

    // Ajustement du debut du sticky pour le banner top
    if ($element.hasClass(this.classes.bannerContentTopClass)) {
      if (this.previousScroll < this.currentScroll) {
        // Scroll vers le bas
        stickyTop = this.$bannerContentTop.outerHeight(true) + this.$header.outerHeight(true)
      } else {
        // Scroll vers le haut
        stickyTop = 0
      }
    }

    // Ajustement si admin bar
    if (Core.isAdminFront()) {
      const adminBarHeight = Core.getAdminBarHeight()

      if (Core.isBpGreaterThan(stickyBp) && $element.hasClass(this.classes.bannerContentTopClass)) {
        stickyTop += adminBarHeight
        windowHeaderTop += adminBarHeight
      } else {
        // Le top du header fixed inclut déjà l'admin bar : simple plancher sous celle-ci
        windowHeaderTop = Math.max(windowHeaderTop, adminBarHeight)
      }
    }

    if (windowHeaderTop < 0) {
      windowHeaderTop = 0
    }

    $element.removeClass(this.stickyClasses.top)
    $element.removeClass(this.stickyClasses.middle)
    $element.removeClass(this.stickyClasses.bottom)

    $element.removeAttr('style')

    if (scrollTopHeader < stickyTop) {
      $element.addClass(this.stickyClasses.top).trigger('sticky:top')
    } else if (scrollTopHeader > stickyBottom) {
      $element.addClass(this.stickyClasses.bottom).trigger('sticky:bottom')
    } else {
      $element.css('top', windowHeaderTop)
      $element.css('left', $element.offset().left)

      if ($element.data(this.stickyDatas.middleWidthOffset) !== undefined) {
        $element.css('width', $element.outerWidth() + parseInt($element.data(this.stickyDatas.middleWidthOffset)))
      } else {
        $element.css('width', $element.outerWidth())
      }

      $element.addClass(this.stickyClasses.middle).trigger('sticky:middle')
    }
  }

  handleStickyNav(e) {
    this.currentScroll = $(window).scrollTop()

    $(`[data-${this.stickyDatas.mobile}], [data-${this.stickyDatas.desktop}]`).each(this.stickyNav.bind(this))

    this.previousScroll = this.currentScroll
  }

  resetClasses($element) {
    $element.removeClass(`${this.stickyClasses.top} ${this.stickyClasses.middle} ${this.stickyClasses.bottom}`)
    $element.removeAttr('style')
  }
}
